import httpCommon from "./http-common";

// Get activity by ID
const getActivity = (publicId: string) => {
  return httpCommon.get(`/v1/get/crmActivity/${publicId}`);
};

// Get all activities for a business
const getAllActivities = (businessId: number, skip = 0, limit = 10) => {
  return httpCommon.get(`/v1/get/crmActivities/${businessId}?skip=${skip}&limit=${limit}`);
};

// Get recent activities for a business
const getRecentActivities = (businessId: number, limit = 5) => {
  return httpCommon.get(`/v1/get/crmActivities/${businessId}?limit=${limit}`);
};

// Get activities for a specific customer
const getCustomerActivities = (customerId: number) => {
  return httpCommon.get(`/v1/get/crmActivitieByCcustomer/${customerId}`);
};

// Get activities for a specific company
const getCompanyActivities = (companyId: number) => {
  return httpCommon.get(`/v1/get/crmActivitiesByCompany/${companyId}`);
};

// Create a new activity
const createActivity = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/crmActivity/${businessId}`, data);
};

// Update an activity
const updateActivity = (publicId: string, data: any) => {
  return httpCommon.put(`/v1/update/crmActivity/${publicId}`, data);
};

// Delete an activity
const deleteActivity = (publicId: string) => {
  return httpCommon.delete(`/v1/delete/crmActivity/${publicId}`);
};

// Search activities
const searchActivities = (businessId: number, searchTerm: string) => {
  return httpCommon.get(`/v1/search/crmActivities/${businessId}?q=${encodeURIComponent(searchTerm)}`);
};

// Get activities count
const getActivitiesCount = (businessId: number) => {
  return httpCommon.get(`/v1/get/count/crmActivities/${businessId}`);
};

// Get activities by type
const getActivitiesByType = (businessId: number, activityType: string) => {
  return httpCommon.get(`/v1/get/crmActivities/${businessId}/type/${activityType}`);
};

// Get upcoming activities
const getUpcomingActivities = (businessId: number) => {
  return httpCommon.get(`/v1/get/crmActivities/${businessId}/upcoming`);
};

const CrmActivitiesService = {
  getActivity,
  getAllActivities,
  getRecentActivities,
  getCustomerActivities,
  getCompanyActivities,
  createActivity,
  updateActivity,
  deleteActivity,
  searchActivities,
  getActivitiesCount,
  getActivitiesByType,
  getUpcomingActivities
};

export default CrmActivitiesService; 